import { render } from "./ProductBrandShowComponent.vue?vue&type=template&id=5e622b02"
import script from "./ProductBrandShowComponent.vue?vue&type=script&lang=js"
export * from "./ProductBrandShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductBrand/ProductBrandShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e622b02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e622b02', __exports__)) {
    api.reload('5e622b02', __exports__)
  }
  
  module.hot.accept("./ProductBrandShowComponent.vue?vue&type=template&id=5e622b02", () => {
    api.rerender('5e622b02', render)
  })

}


export default __exports__